import React, { useState } from 'react';
import { Button, Col, Image, Row } from 'antd';
import './style.css'
import { SendLink, getPatientCostReceipt, getPatientResultReport } from '../../../api/api';
import { errorNotify, sucessNotify } from '../../../services/toast.notification';
import toast from 'react-hot-toast';
//import DownloadPdfFile from '../../../components/_common/DownloadZipFile/PdfFile';
import Spinner from '../../../components/_common/Spinner';
import DownloadPDF from '../../../components/_common/DownloadZipFile/DownloadPdfFile';
//import { url } from 'inspector';

export interface InputProps {
    data: any,
    url:any,
    serviceUrl:any
}


const SearchResult = ({ data,url ,serviceUrl}: InputProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const [patientResultReportSource, setPatientResultReportSource] = useState("");
    const [isPatientResultReportSource, setIsPatientResultReportSource] = useState(false);

    let toastId: any;

    const _getPatientResultReport = (url: string, AdmitID: number, app: number, _IncludeInCompletePatient: boolean, _IncludePrintedPatient: boolean, _IncludedNotConfirmedPatient: boolean) => {
        setIsLoading(true);
        getPatientResultReport(url, AdmitID, app, _IncludeInCompletePatient, _IncludePrintedPatient, _IncludedNotConfirmedPatient)
            .then((result: any) => {
                if (result.data !== "") {
                    toastId = toast.loading('...درحال آماده سازی فایل گزارش');

                    //let pdfArray: any[] = [];

                    //pdfArray.push(`${result.data.Base64PDF}`);
                    //DownloadPdfFile(pdfArray, "گزارش جواب");
                    DownloadPDF(result.data.Base64PDF, AdmitID.toString());

                    setPatientResultReportSource(result.data.Base64PDF);
                    setIsPatientResultReportSource(true);
                    //console.log(result.data.json); 

                    toast.dismiss(toastId);
                    setIsLoading(false);
                    //setData(result.Base64PDF);

                }
                else {
                    errorNotify("داده ای برای نمایش وجود ندارد!");
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const _getPatientResultReportClick = () => {
        _getPatientResultReport(serviceUrl, data.str_AdmitPatinet, data.app, false, true, false);
    }

    const _getPatientCostReceipt = (url: string, AdmitID: number, app: number) => {
        setIsLoading(true);
        getPatientCostReceipt(url, AdmitID, app)
            .then((result: any) => {
                if (result !== "") {
                    toastId = toast.loading('...درحال آماده سازی فایل قبض');

                    //let pdfArray: any[] = [];

                    // pdfArray.push(`${result}`);
                    // DownloadPdfFile(pdfArray, "قبض");
                    DownloadPDF(result, AdmitID.toString())
                    setPatientResultReportSource(result);
                    setIsPatientResultReportSource(true);
                    //console.log(result.data.json); 

                    toast.dismiss(toastId);
                    //setData(result.Base64PDF);
                    setIsLoading(false);

                }
                else {
                    errorNotify("داده ای برای نمایش وجود ندارد!");
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const _getPatientCostReceiptClick = () => {
        _getPatientCostReceipt(serviceUrl,data.str_AdmitPatinet,data.app);
    }

    const _sendLinkClick = () => {
        setIsLoading(true);
        SendLink(url,data.str_AdmitPatinet,data.app)
            .then((result: any) => {
                sucessNotify("لینک ارسال شد.");
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }


    return (
        <>
            <Row style={{ display: 'flex', justifyContent: 'center' }}>
                <Image
                    className={data.Int_Emeregency ? 'icon-active-style' : 'icon-style'}
                    src='../assets/icon/ambulance.png'
                />
                <Image
                    className={data.Int_InterviewBy > 0 ? 'icon-active-style' : 'icon-style'}
                    src='../assets/icon/meeting.png'
                />
                <Image
                    className={data.IsPregnant === "1" ? 'icon-active-style' : 'icon-style'}
                    src='../assets/icon/pregnancy.png'
                />
                <Image
                    className={data.Int_InsOnlineAdmitState == 1 ? 'icon-active-style' : 'icon-style'}
                    src='../assets/icon/up.png'
                />
                <Image
                    className={data.Bit_VIP ? 'icon-active-style' : 'icon-style'}
                    src='../assets/icon/vip.png'
                />
            </Row>
            <Row>
                <Col md={12}>
                    <span style={{ color: 'gray' }}>نام:</span> <span>{data.Str_Name}</span>
                </Col>
                <Col md={12}>
                    <span style={{ color: 'gray' }}>کد ملی:</span> <span>{data.Int_NationalCode}</span>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <span style={{ color: 'gray' }}>پذیرش:</span> <span>{data.str_AdmitPatinet}</span>
                </Col>
                <Col md={12}>
                    <span style={{ color: 'gray' }}>پذیرش:</span> <span>{data.Str_AdmitDate_Shamsi}  {data.Str_AdmitTime}</span>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <span style={{ color: 'gray' }}>سازمان:</span> <span>{data.OrgName}</span>
                </Col>
                <Col md={12}>
                    <span style={{ color: 'gray' }}>جواب:</span> <span>{data.Str_SapajaResultDate}</span>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <span style={{ color: 'gray' }}>پزشک:</span> <span>{data.Str_DrFullName}</span>
                </Col>
                <Col md={12}>
                    <span style={{ color: 'gray' }}>تولد:</span> <span>{data.str_PatientBrithDay}</span>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <span style={{ color: 'gray' }}>مرحله:</span> <span>{data.Str_WIP}</span>
                </Col>
                <Col md={12}>
                    <span style={{ color: 'gray' }}>باقیمانده:</span> <span>{data.Int_LastReminder}</span>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <span style={{ color: 'gray' }}>تلفن:</span> <span>{data.Str_Mobile}</span>
                </Col>
                <Col md={12}>
                    <span style={{ color: 'gray' }}>اشتراک:</span> <span>{data.Frk_PatientInfo}</span>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <span style={{ color: 'gray' }}>پذیرشگر:</span> <span>{data.Str_AdmitterName}</span>
                </Col>

            </Row>

            <Row style={{ justifyContent: 'center', marginTop: '20px' }}>
                <Button type="primary" style={{ marginLeft: '10px' }} onClick={_getPatientResultReportClick} >
                    دریافت جواب
                </Button>
                <Button type="primary" style={{ marginRight: '10px' }} onClick={_getPatientCostReceiptClick} >
                    چاپ قبض
                </Button>
                <Button type="primary" style={{ marginRight: '10px' }} onClick={_sendLinkClick} >
                    ارسال لینک
                </Button>
            </Row>
            {isLoading === false && (
                <div style={{ marginTop: '40px', marginBottom: '20px' }}>
                    {isPatientResultReportSource && (
                        <center><embed src={`data:application/pdf;base64,${patientResultReportSource}`} style={{ width: '90%', height: '500px' }} /></center>)}

                </div>
            )
            }
            {isLoading && (
                <Spinner />
            )
            }

        </>
    )

}

export default SearchResult;